//Flat pack Kitchens with Handle's
export const RANGE_PRICES = {
  ascoli: [1756, 2757, 3691, 4763],
  tatton: [1849, 2918, 4050, 5251],
  nova: [1863, 2957, 4019, 5230],
  ambleside: [2333, 3695, 5059, 6588],
  brunswick: [2442, 3859, 5333, 6938],
  hoxton: [2530, 3983, 5410, 7067],
  portobello: [2530, 3983, 5410, 7067],
  soho: [2821, 4371, 5851, 7844],
  dunham: [2806, 4400, 5899, 7832],
  nordicNature: [2891, 4562, 6183, 8113],
  ludlow: [3239, 5110, 6870, 9067],
  wardley: [3239, 5110, 6870, 9067],
}
//Prebuilt Kitchens
export const PREBUILT_RANGES_PRICES = {
  ascoli: [2239, 3528, 4876, 6285],
  tatton: [2364, 3684, 5227, 6704],
  nova: [3025, 4792, 6698, 8617],
  luna: [3163, 5170, 7023, 9085],
  ambleside: [3772, 5966, 8357, 10766],
  brunswick: [3952, 6238, 8748, 11277],
  hoxton: [4072, 6412, 8834, 11435],
  portobello: [4072, 6412, 8834, 11435],
  duxbury: [3999, 6327, 8861, 11418],
  soho: [4416, 6872, 9533, 12549],
  dunham: [4434, 6964, 9608, 12582],
  nordicNature: [4640, 7318, 10081, 13093],
  ludlow: [5103, 8055, 11159, 14525],
  wardley: [5103, 8055, 11159, 14525],
  reed: [5487, 8693, 12208, 15834],
  bewdley: [5392, 8530, 11842, 15382],
}
//Flat pack Kitchens with Handless
export const HANDLELESS_RANGE_PRICES = {
  ascoli: [2438, 3913, 5395, 6972],
  nova: [3523, 5772, 7993, 10199],
  brunswick: [4468, 7102, 10002, 12886],
  hoxton: [4594, 7278, 10078, 13041],
  portobello: [4594, 7278, 10078, 13041],
  soho: [4897, 7707, 10806, 14180],
  dunham: [4929, 7829, 10913, 14265],
  nordicNature: [5263, 8344, 11475, 14891],
  wardley: [5664, 9036, 12649, 16431],
  ludlow: [5664, 9036, 12649, 16431],
  luna: [1932, 3197, 4214, 5515],
  duxbury: [2471, 3918, 5363, 6986],
}

export const WORKTOP_PRICES = {
  bullNosedLaminate: [145, 290, 435, 621],
  squareEdgedLaminate: [240, 481, 721, 962],
  compactLaminate: [623, 1246, 1868, 2491],
  timber: [692, 1384, 2076, 2768],
  minerva: [1152, 2304, 3456, 4608],
  silestone: [2182, 2617, 3067, 4233],
  corian: [3086, 4044, 5054, 7365],
  dekton: [2745, 3507, 4316, 6164],
}

export const INSTALLATION_PRICES = {
  dryFitInstallation: [1562, 2149, 2883, 3269],
  wetFitInstallation: [2251, 2951, 3685, 3958],
}

export const INSTALLATION_FEE = 500

export const DRY_FIT_BAND_PRICES = {
  A: [1486, 2045, 2744, 3112],
  B: [1547, 2133, 2867, 3254],
  C: [1612, 2228, 2999, 3404],
  D: [1674, 2318, 3123, 3546],
}

export const WET_FIT_BAND_PRICES = {
  A: [2144, 2811, 3510, 3770],
  B: [2239, 2939, 3673, 3946],
  C: [2340, 3076, 3847, 4131],
  D: [2439, 3209, 4014, 4311],
}

export const FLOORING_PRICES = {
  laminate: [214, 299, 384, 469],
  amtico: [311, 466, 621, 777],
  engineered: [367, 550, 733, 917],
}

export const APPLIANCES_PRICES = {
  beko: [844, 1158, 1708, 2217],
  bosch: [1357, 1992, 2908, 3567],
  smeg: [1682, 2067, 2787],
  aeg: [1744, 2251, 2965, 3934],
  neff: [2089, 2637, 3464, 4282],
  siemens: [3414, 4433, 5404, 6219],
  miele: [3842, 4952, 6345, 7386],
}

export const SINK_PRICES = {
  frankeAscona: [256, 345],
  square: [275, 379],
  composite: [287, 413],
  ceramic: [447, 517],
  belfast: [483, 551],
}

export const HANDLES_TYPE_VALUES_WITH = [{ value: 'With handles', key: 0 }]

export const HANDLES_TYPE_VALUES_WITHOUT = [{ value: 'Handleless', key: 1 }]

export const HANDLES_TYPE_VALUES_COMBINED = [
  { value: 'With handles', key: 0 },
  { value: 'Handleless', key: 1 },
]

export const SINKS_TYPE_VALUES = [
  { value: '1 Bowl', key: 0 },
  { value: '1.5 Bowl', key: 1 },
]

export const APPLIANCES_NAME_VALUES = [
  { value: 'Select brand', key: 0 },
  { value: 'Beko(£)', key: 1 },
  { value: 'Bosch(£)', key: 2 },
  { value: 'AEG 6000(££)', key: 3 },
  { value: 'Neff(££)', key: 4 },
  { value: 'Smeg(££)', key: 5 },
  { value: 'Miele(£££)', key: 6 },
  { value: 'Siemens(£££)', key: 7 },
]

export const APPLIANCES_NAME_VALUES_SMEG_EXCEPTION = [
  { value: 'Select brand', key: 0 },
  { value: 'Beko(£)', key: 1 },
  { value: 'Bosch(£)', key: 2 },
  { value: 'AEG 6000(££)', key: 3 },
  { value: 'Neff(££)', key: 4 },
  { value: 'Miele(£££)', key: 5 },
  { value: 'Siemens(£££)', key: 6 },
]
